import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const ShopHardware = () => (
  <div>Shop Hardware</div>
);

export default withStyles(styles)(ShopHardware);
